import {mmap} from '@freckle/maybe'
import type {ButtonStyleT} from '@freckle/educator-materials/ts/components/button'
import {Button} from '@freckle/educator-materials/ts/components/button'
import Warning from '@freckle/school/ts/rostering/components/common/warning'
import {btnWrapper, warning} from './confirm-button.module.scss'

type Props = {
  text: string
  onConfirm?: () => void
  dataTest?: string
  warn?: string
  style?: ButtonStyleT
}

export default function ConfirmButton(props: Props) {
  const {onConfirm, text, warn, dataTest, style} = props
  return (
    <div className={btnWrapper}>
      {mmap(
        text => (
          <Warning className={warning} text={text} />
        ),
        warn,
      )}
      <Button
        dataTest={dataTest}
        onClick={onConfirm}
        disabled={onConfirm === undefined}
        style={style}
      >
        {text}
      </Button>
    </div>
  )
}
